import React, { useState } from "react";
import {
  TextField,
  InputLabel,
  NativeSelect,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import CheckedIcon from "src/assets/checked.jpg";
import UncheckedIcon from "src/assets/unchecked.jpg";

const renderField = ({
  type,
  input,
  label,
  meta: { touched, error },
  options = [],
  disabled,
  initValue,
  id,
  showError,
  placeholder,
  required,
  ...custom
}) => {
  let formField;
  switch (type) {
    case "select": {
      // let value = initValue ? "" : null;
      formField = (
        <>
          <NativeSelect
            disabled={disabled}
            error={touched && error}
            helpertext={touched && error && showError ? error : ""}
            onChange={(event) => {
              input.onChange(event.target.value);
            }}
            {...input}
            {...custom}
          >
            {options.map((option) => (
              <option value={option.value}>{option.label}</option>
            ))}
          </NativeSelect>
        </>
      );
      break;
    }
    case "check": {
      formField = (
        <Checkbox
          label={label}
          disabled={disabled}
          onClick={(e) => input.onChange(e.target.checked)}
          checkedIcon={
            <img width="16rem" src={CheckedIcon} alt="checked-icon" />
          }
          icon={<img width="16rem" src={UncheckedIcon} alt="unchecked-icon" />}
          {...input}
          {...custom}
        />
      );
      break;
    }
    case "radio": {
      formField = (
        <RadioGroup
          onChange={(e) => input.onChange(e.target.value)}
          {...input}
          {...custom}
        >
          {options.map(({ label, value }) => {
            return (
              <FormControlLabel
                value={value}
                label={label}
                disabled={disabled}
                control={<Radio {...custom} />}
              />
            );
          })}
        </RadioGroup>
      );
      break;
    }
    case "input":
    default: {
      formField = (
        <TextField
          disabled={disabled}
          type="text"
          error={touched && error}
          placeholder={placeholder}
          onChange={(event) => {
            input.onChange(event.target.value);
          }}
          {...input}
          {...custom}
        />
      );
    }
  }
  return (
    <div>
      <InputLabel id={`${type}-label-${id}`}>
        {label}
        <span className="dot">{required && label && "*"}</span>
      </InputLabel>
      {formField}
      {showError && touched && error && <div className="error">{error}</div>}
    </div>
  );
};

const DatePicker = ({
  type,
  input,
  label,
  // meta: { touched, error },
  options = [],
  disabled,
  initValue,
  id,
  // ...custom
}) => {
  const [day, setDay] = useState();
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MobileDatePicker
        value={day}
        onChange={(newValue) => {
          setDay(newValue);
          input.onChange(newValue);
        }}
        renderInput={(params) => <TextField {...params} helperText={null} />}
      />
    </LocalizationProvider>
  );
};

export { renderField, DatePicker };
